export class QueryParams {

  public params: any = {};
  public paramString: string = '';

  private static valueToString(value) {
    let result = '';

    if (Array.isArray(value) && (value.length)) {
      result += '[';
      for (let index = 0; index < value.length; index++) {
        result += value[index] + ((index !== (value.length - 1)) ? ',' : '');
      }

      result += ']';
    } else {
      result += value;
    }

    return result;
  }

  constructor() {
  }

  setQueryParam(key: string, value: any[] | string | null | undefined): void {
    if (value && (!Array.isArray(value) || (value.length > 0))) {
      if (Object.keys(this.params).length === 0) {
        this.paramString = '?' + key + '=' + QueryParams.valueToString(value);
      } else {
        if (this.params[key]) {
          this.paramString = this.paramString.replace(
            key + '=' + QueryParams.valueToString(this.params[key]),
            key + '=' + QueryParams.valueToString(value)
          );
        } else {
          this.paramString = this.paramString + '&' + key + '=' + QueryParams.valueToString(value);
        }
      }

      this.params[key] = value;
    } else {
      if (this.params[key]) {
        if (Object.keys(this.params).length === 1) {
          this.paramString = '';
        } else {
          this.paramString = this.paramString
            .replace(key + '=' + QueryParams.valueToString(this.params[key]), '')
            .replace('&&', '&').replace('?&', '?');
        }

        delete this.params[key];
      }
    }
  }

  getQueryParam(key: string) {
    return this.params[key];
  }

  resetQueryParams() {
    this.params = {};
    this.paramString = '';
  }

  hasQueryParams(): boolean {
    return (Object.keys(this.params).length > 0);
  }
}
